export const environment = {
    production: true,
    client_id: 'gBhj0spNXLy3pA',
    client_secret: 'WzMUMN7ODbycIotX7rd8pRrD_Mg',
    redirectUri: 'https://reddit-post-notifier.firebaseapp.com/home',
    baseUri: 'https://reddit-post-notifier.firebaseapp.com',

    firebase: {
      apiKey: 'AIzaSyBCatq71G5z8cBUC_Iao7mJUr6vNoXVF5Q',
      authDomain: 'reddit-post-notifier.firebaseapp.com',
      databaseURL: 'https://reddit-post-notifier.firebaseio.com',
      projectId: 'reddit-post-notifier',
      storageBucket: 'reddit-post-notifier.appspot.com',
      messagingSenderId: '77333801053'

    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts